import EmptyBoxImage from "@ch/assets/images/empty-state-img.svg";
import type { ReactNode } from "react";

interface EmptyStateProps {
  title?: string;
  info?: string | ReactNode;
  action?: ReactNode;
  image?: string;
  addImage?: boolean;
  imageClassName?: string;
  className?: string;
}

const EmptyStateComponent = ({
  title,
  info,
  action,
  addImage,
  image,
  imageClassName,
  className,
}: EmptyStateProps) => {
  return (
    <div
      className={`flex flex-col items-center gap-8 rounded-2xl bg-white p-6 lg:gap-12 ${className ?? ""}`}
    >
      {addImage === false ? (
        ""
      ) : (
        <img
          alt="empty-box"
          className={imageClassName}
          src={image ?? EmptyBoxImage}
          width={172}
        />
      )}

      <div className="w-full min-w-0 max-w-sm px-2 text-center sm:max-w-md">
        <h2 className="pb-2.5 text-lg font-semibold leading-snug sm:text-xl">
          {title ?? "Nothing to See Here"}
        </h2>
        {info &&
          (typeof info === "string" ? (
            <p className="text-gray">{info}</p>
          ) : (
            <div className="text-gray">{info}</div>
          ))}
      </div>

      {action && <div>{action}</div>}
    </div>
  );
};

export default EmptyStateComponent;
